<script lang="ts">
  import ClassicCard from './ClassicCard.svelte'
  import type {Classic} from '../types'
  import {t} from '../i18n'
  import LoadMore from '../shared/LoadMore.svelte'
  import SearchInput from '../shared/SearchInput.svelte'
  import Placeholder from '../shared/Placeholder.svelte'

  let classics: Classic[]
  let search = new URLSearchParams(window.location.search).get('query') || ''
</script>

<div class="row">
  <div class="grid-section">
    <div class="heading with-filter inner-heading">
      <h2>{t.classics.recommended.title}</h2>

      <div class="right-filter">
        <SearchInput bind:search placeholder={t.classics.find}/>
      </div>
    </div>

    {#if classics && classics.length}
      <div class="grid three">
        {#each classics as classic}
          <div class="grid__item">
            <ClassicCard {classic}/>
          </div>
        {/each}
      </div>
    {:else}
      <Placeholder placeholder={t.placeholder.no_classics} loading={!classics}/>
    {/if}

    <LoadMore url="/classics" bind:items={classics} {search}/>
  </div>
</div>